<div class="patient-details">
    <div class="detail-card">
      Name: <span>{{ patientDetails.name }}</span>
    </div>
    <div class="detail-card">
      Age: <span>{{ patientDetails.age }}</span>
    </div>
    <div class="detail-card">
      Sex: <span>{{ patientDetails.sex }}</span>
    </div>
    <div class="detail-card">
      Visit Count: <span>{{ patientDetails.visitCount }}</span>
    </div>
    <div class="detail-card">
      Date Of Admission: <span>{{ patientDetails.admissionDate }}</span>
    </div>
    <div class="detail-card">
      UHID No: <span>{{ patientDetails.uhidNo }}</span>
    </div>
    <div class="detail-card">
      Barcode: <span>{{ patientDetails.uhidNo }}</span>
    </div>
    <div class="detail-card">
      Complaint: <span>{{ patientDetails.complaint }}</span>
    </div>
    <div class="detail-card">
      Weight: <span>{{ patientDetails.weight }}</span>
    </div>
    <div class="detail-card">
      Pulse: <span>{{ patientDetails.pulse }}</span>
    </div>
    <div class="detail-card">
      BP: <span>{{ patientDetails.bp }}</span>
    </div>
    <div class="detail-card">
      Temp: <span>{{ patientDetails.temp }}</span>
    </div>
    <div class="detail-card">
      SPO2: <span>{{ patientDetails.spo2 }}</span>
    </div>
  </div>